import { render, staticRenderFns } from "./InfoStudentBill.vue?vue&type=template&id=5572327e&"
import script from "./InfoStudentBill.vue?vue&type=script&lang=js&"
export * from "./InfoStudentBill.vue?vue&type=script&lang=js&"
import style0 from "./InfoStudentBill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports